// services/categoryService.js
import api from './baseAPIService';

// Function to create a new category
// FASTAPI integrated
export const createCategory = async (categoryData) => {
  try {
    const response = await api.post('/categories/create', categoryData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Function to load all categories
// FASTAPI integrated
export const loadCategories = async () => {
  const response = await api.get('/categories/get-all');
  return response.data;
};

// Function to update an existing category
// FASTAPI integrated
export const updateCategory = async (categoryId, categoryData) => {
  const response = await api.put(`/categories/update/${categoryId}/`, categoryData);
  return response.data;
};

// Function to delete an existing category
// FASTAPI integrated
export const deleteCategory = async (categoryId) => {
  const response = await api.delete(`/categories/delete/${categoryId}/`);
  return response.data;
};

// Create question
// FASTAPI integrated
export const createQuestion = async (questionData) => {
  try {
    const formData = new FormData();
    
    // Append text fields
    formData.append('question_text', questionData.question_text);
    formData.append('answer_text', questionData.answer_text);
    formData.append('explanation_text', questionData.explanation_text || '');
    formData.append('category_id', questionData.category_id);

    // Append image files if they exist
    if (questionData.question_image instanceof File) {
      formData.append('question_image', questionData.question_image);
    }
    if (questionData.answer_image instanceof File) {
      formData.append('answer_image', questionData.answer_image);
    }
    if (questionData.explanation_image instanceof File) {
      formData.append('explanation_image', questionData.explanation_image);
    }

    const response = await api.post('/questions/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

// Update question
// FASTAPI integrated
export const updateQuestion = async (questionId, questionData) => {
  try {
    const formData = new FormData();
    
    // Append text fields
    formData.append('question_text', questionData.question_text);
    formData.append('answer_text', questionData.answer_text);
    formData.append('explanation_text', questionData.explanation_text || '');
    formData.append('category_id', questionData.category_id);

    // Append image deletion flags if they exist
    if (questionData.image_update) {
      formData.append('delete_question_image', questionData.image_update.delete_question_image);
      formData.append('delete_answer_image', questionData.image_update.delete_answer_image);
      formData.append('delete_explanation_image', questionData.image_update.delete_explanation_image);
    }

    // Append image files if they exist and are new File objects
    if (questionData.question_image instanceof File) {
      formData.append('question_image', questionData.question_image);
    }
    if (questionData.answer_image instanceof File) {
      formData.append('answer_image', questionData.answer_image);
    }
    if (questionData.explanation_image instanceof File) {
      formData.append('explanation_image', questionData.explanation_image);
    }

    const response = await api.put(`/questions/${questionId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};


// Function to delete an existing question
// FASTAPI integrated
export const deleteQuestion = async (questionId) => {
  const response = await api.delete(`/questions/delete/${questionId}/`);
  return response.data;
};

// Function to load questions by catalog
// FASTAPI integrated
export const loadQuestionsByCatalog = async (catalogId) => {
  const response = await api.get(`/catalogs/${catalogId}/questions`);
  return response.data;
};

// Function to load all categories and all question catalogs
// FASTAPI integrated
export const loadAllCategoriesAndAllQuestionCatalogs = async () => {
  try {
    const response = await api.get('/categories/statistics-all-categories/');
    return response.data;
  } catch (error) {
    console.error("Error loading all categories and all question catalogs:", error);
    throw error.response ? error.response.data : new Error("Network error");
  }
};

// Function to load all questions and all categories
// FASTAPI integrated
export const loadAllQuestionsAndAllCategories = async () => {
  try {
    const response = await api.get('/questions/questions/stats');
    return response.data;
  } catch (error) {
    console.error("Error loading all questions and all categories:", error);
    throw error.response ? error.response.data : new Error("Network error");
  }
};

// Function to load learning statistics
// FASTAPI integrated
export const getLearningStatistics = async () => {
  try {
    const response = await api.get('/learning/statistics');
    return response.data;
  } catch (error) {
    console.error("Error loading learning statistics:", error);
    throw error.response ? error.response.data : new Error("Network error");
  }
};

export const loadQuestionsWithCategoriesAdmin = async () => {
  const response = await api.get('/questions/admin/with-categories');
  return response.data;
};

// Function to load spaced learning questions
// FASTAPI integrated
export const loadSpacedLearningQuestions = async () => {
  try {
    const response = await api.get('/learning/spaced-learning/');
    return response.data;
  } catch (error) {
    console.error("Error loading spaced learning questions:", error);
    throw error.response ? error.response.data : new Error("Network error");
  }
};

export const getQuestionById = async (questionId) => {
  const response = await api.get(`/questions/${questionId}`);
  return response.data;
};